import { OPEN_HELP_MENU, OPENED_HELP_MENU } from '../constants/types'

const initialState = {
    openHelpMenu: false,
}

const globalConfig = (state = initialState, action: any) => {
    switch (action.type) {
        case OPEN_HELP_MENU:
            return {
                ...state,
                openHelpMenu: true,
            }
        case OPENED_HELP_MENU:
            return {
                ...state,
                openHelpMenu: false,
            }
        default:
            return state
    }
}

export default globalConfig
